import React, { useState } from "react";
import { Input, Modal, Select } from "antd";
import { meetingSDK } from "unifiedring-sdk";
import store from "../../../../context/store/store";
import { URButton } from "../../../../shared/widgets/button";
import styles from "../meetingStart/startMeeting.module.scss";
import loaderblue from '../../../../styles/images/file_loader.svg';
import _ from "lodash";

type JoinMeetingPopupState = {
  uuid: string;
  password: string;
  selectedItem: any;
  searchKey: string;
  isLoading: boolean;
  isModalVisible: boolean;
  meetingList: Array<any>;
  participantName: string;
  isIdError: boolean;
  errorMsg: string;
  isPassword:boolean;
  passwordInput:string;
  isPwdError:boolean;
}

type JoinMeetingPopupProps = { joinMeetingStatus: Function; }

export default function JoinMeetingPopup({joinMeetingStatus}:JoinMeetingPopupProps) {
  const { Option } = Select;
  let userData = store.getState().loginReducer.userdetails || [];
  const [getData, setData] = useState<JoinMeetingPopupState>({
    isModalVisible: true,
    isLoading: true,
    meetingList: [],
    uuid: '',
    password: '',
    participantName: userData.caller_id,
    searchKey: '',
    selectedItem: [],
    isIdError: false,
    errorMsg:'',
    isPassword:false,
    passwordInput:'',
    isPwdError: false
  });

  const join = () => {
if((getData.selectedItem['uuid'] !== "" && !getData.isPassword && !_.isUndefined(getData.selectedItem['uuid'])) || ( !_.isUndefined(getData.selectedItem['uuid'])&& getData.password === getData.passwordInput )){
  setData({ ...getData, isModalVisible: false, uuid:'', password:'' });
  joinMeetingStatus(false);
       let replaced_url:any=getData.selectedItem['invite_url']?.includes("stagemeet") ? getData.selectedItem['invite_url'] : getData.selectedItem['invite_url']?.replace('meet.unifiedring', 'meet.worktual');
     window.open(replaced_url, '_blank'); 
}
else if(getData.selectedItem['uuid'] ==="" || _.isUndefined(getData.selectedItem['uuid']))
{setData({ ...getData, isIdError: true, errorMsg:'Please choose valid meeting' });}
  
  else if(getData.passwordInput ==="" || getData.password !== getData.passwordInput){
    setData({ ...getData, isPwdError: true, errorMsg:'Password mismatch' });
    }
    else{
      console.log("need to handle");
    }
}
  
  // const joinMeeting = () => {
  //   if (getData.uuid !== '') {
  //     setData({ ...getData, isModalVisible: false, uuid:'', password:'' });
  //     joinMeetingStatus(false);
  //     window.open(getData.selectedItem["invite_url"]);
  //   }
  //   else {
  //     setData({ ...getData, isError: true, errorMsg:'Please choose valid meeting' });
  //   }
  // };

  const handleCancel = () => {
    setData({ ...getData, isModalVisible: false });
    joinMeetingStatus(false);
  };

  const getMeetingDetail = (searchKey:string) => {
    let filterData:any = {
      offset:0, limit:20,
      searchText: searchKey
    };
    new meetingSDK.MeetingRestService().getAliveMeetings(filterData).then((data: any) => {
      if (data['statusCode'] === 200) {
        setData({...getData, isLoading: false, meetingList: data['result'],isIdError:false,isPwdError:false, uuid:'' });
      }
      else { setData({...getData, isLoading: false }); }
    })
      .catch((err:any) => { setData({...getData, isLoading: false,isIdError:false,isPwdError:false, uuid:'' }); });
  };

  const meetinglistOnchange = (e: any) => {

    try {
      let selected_Data = JSON.parse(e);
      setData({
        ...getData, isLoading: false, uuid: selected_Data['uuid'],password:selected_Data['password'],
        selectedItem: selected_Data,isPassword:selected_Data['password'] ? true :false
      });
    } catch (error) {
      console.log("meetinglistOnchange >>>>>", error)
    }

  };

  const enterPassword=(e:any)=>{
    setData({...getData,passwordInput:e.target.value});
  }

  return (
    <>
      <Modal visible={getData.isModalVisible} className={`${"meetNowmodal"} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={handleCancel} />
        <h2 className="modalTitle">Join Meeting</h2>
        <div className={`${styles.inputBoxes} ${styles.selectdropload}`}>
          <label>Choose a meeting</label>
          <Select
            placeholder={"Enter a Meeting name (or) meeting ID"}
            // mode="multiple"
            loading={getData.isLoading}
            showSearch = {true}
            onChange={meetinglistOnchange}
            onSearch={(e:any)=>getMeetingDetail(e)}
            className='cusSelBox'
            dropdownClassName='customSelectdrp'
            filterOption={false}
            onFocus={(e: any) => getMeetingDetail('')}
          >
            {getData.meetingList.map((value: any, index: number) => {
              return (
                <>
                  <Option value={JSON.stringify(value)}
                    key={index}>{value.title}</Option>
                </>
              );}
            )}
          </Select>
          {getData.isIdError && <p className="error joinmeeterror">{getData.errorMsg}</p>}
           {getData.isLoading && <div className={`${styles.loadingSec} ${styles.loaddropiconright}`}>
            <object data={loaderblue} type="image/svg+xml">Loading...</object>
           </div>}
        </div>
        
        {getData.isPassword  &&
        <div className={styles.inputBoxes}>
          <label>Password</label>
          <Input.Password placeholder="Enter Password" type="password" autoComplete="new-password"   className="inputcustomBox" value={ getData.passwordInput } onChange={(e:any)=>enterPassword(e)}/>
            {getData.isPwdError && <p className="error joinmeeterror">{getData.errorMsg}</p>}
        </div>
        }
        <div className={styles.inputBoxes}>
          <label>Your Name</label>
          <Input value={getData.participantName} className="inputcustomBox" disabled />
          {/* <URInput placeHolder="Enter a Meeting Name (or) Meeting ID" className="inputcustomBox"
            value={getData.participantName} disabled={true}/> */}
        </ div>
        <div className={styles.footersection}>
          <URButton className='urButton buttonWhite mr8' onClick={handleCancel} name="Cancel"></URButton>
          <URButton className='urButton buttonBlue' onClick={join} name="Join Meeting"></URButton>
        </div>
      </Modal>
    </>
  );
};

